import React, { useState, useEffect } from "react";
import { Box, Button, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { IconButtonComponent } from "../../../component/atom";
import { PdfComponent } from "../../../component/molecule";
import DocumentRepository from "../../../core/repository/DocumentRepository";
import ImageDocumentView from "../../../component/molecule/Pdf/imageComponent";

const IMAGE_EXTENSIONS = ["png", "jpg", "jpeg", "gif", "webp", "bmp", "svg"];

const getFileExtension = (value = "") => {
  const clean = String(value).split("?")[0].toLowerCase();
  return clean.split(".").pop() || "";
};

const getFileType = (fileName, filePath) => {
  const ext = getFileExtension(fileName) || getFileExtension(filePath);
  if (ext === "pdf") return "pdf";
  if (IMAGE_EXTENSIONS.includes(ext)) return "image";
  return "other";
};

const DocumentViewScreen = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [filePath, setFilePath] = useState(null);
  const [fileName, setFileName] = useState("");
  const [loading, setLoading] = useState(true);
  const [documentId, setDocumentId] = useState(null);

  useEffect(() => {
    const document = location?.state?.document;
    setFileName(document?.name || "");
    setDocumentId(document?.id || null);
    if (document?.id) {
      fetchFileUrl(document.id, document?.name);
    } else {
      setLoading(false);
    }
  }, [location]);

  const fetchFileUrl = async (documentId, name) => {
    try {
      setLoading(true);
      const fileData = await DocumentRepository.getFileUrl(documentId);
      if (fileData && !fileData.error && fileData.file_path) {
        setFilePath(fileData.file_path);
        setFileName(name || "");
      }
    } catch (error) {
      console.error("Error fetching file URL:", error);
    } finally {
      setLoading(false);
    }
  };

  const fileType = getFileType(fileName, filePath);

  return (
    <Box>
      <Box>
        <IconButtonComponent
          onclick={() => {
            if (location?.state?.returnPath) {
              navigate(location.state.returnPath, {
                state: location.state.returnState,
                replace: true,
              });
              return;
            }
            navigate(-1);
          }}
          btnType="backbtn"
          btnText="Back"
        />
      </Box>
      {!loading && filePath && fileType === "pdf" && (
        <PdfComponent
          documentId={documentId}
          pdfFile={{
            id: documentId,
            data: { id: documentId, file_path: filePath },
            name: fileName,
          }}
        />
      )}
      {!loading && filePath && fileType === "image" && (
        <ImageDocumentView filePath={filePath} fileName={fileName} />
      )}
      {!loading && filePath && fileType === "other" && (
        <Box
          sx={{
            mt: 2,
            p: 3,
            border: "1px solid #e0e0e0",
            borderRadius: 4,
            textAlign: "center",
          }}
        >
          <Typography sx={{ mb: 2, fontWeight: 600 }}>
            {fileName?.replace(/\.[^/.]+$/, "")}
          </Typography>
          <Typography sx={{ mb: 2, color: "#6b7c93" }}>
            Preview is not available for this file type.
          </Typography>
          <Button
            variant="contained"
            onClick={() => window.open(filePath, "_blank")?.focus()}
            sx={{
              backgroundColor: "#9834F0",
              "&:hover": { backgroundColor: "#7a29c0" },
            }}
          >
            Open File
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default connect(() => ({}), {})(DocumentViewScreen);
